module.exports = __webpack_public_path__ + "img/get_img.3916aee6.png";